const resources = {
    giftFinder: 'Explorateur cadeaux'
};

export default function getResource(label) {
    return resources[label];
}
